import normalizeBreakpointsArray from './normalizeBreakpointsArray'

const expandVariants: BaseTheme.ExpandVariants =
  (variant, themeObject) =>
  ({theme}) => {
    if (!variant) {
      return null
    }

    if (Array.isArray(variant)) {
      const normalizedValue = normalizeBreakpointsArray(variant, theme) as string[]

      return normalizedValue
        .map((v, i) => {
          if (v && themeObject[v]) {
            return theme.normalizeStyles(themeObject[v], theme.viewportsArray[i])
          }
          return false
        })
        .filter(Boolean)
    } else if (themeObject[variant]) {
      return theme.normalizeStyles(themeObject[variant])
    }

    return null
  }

export default expandVariants
